export const SESSION_KEY = "CopperSessionKey";